import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Urls } from '../../../utils/urls';
import { ApiService } from '../../../shared/services/api.service';
import { CommonDataService } from '../../../shared/services/common-data.service';
import { FileInputComponent } from '@common/file-input/file-input';
import { Something_went_wrong, Thank_You } from "@root/app.constant";
import { environment } from '../../../../environments/environment.prod'

@Component({
  selector: 'app-call-back-mobile',
  templateUrl: './call-back-mobile.component.html',
  styleUrls: ['./call-back-mobile.component.scss']
})
export class CallBackMobileComponent implements OnInit {

  userData: any = {};
  firstName: string;
  lastName: string;
  cityList = [];
  mobNumberPattern = "^((\\+91-?)|0)?[6-9][0-9]{9}$";
  alphaPattern = '^[a-zA-Z ]*$';
  msgPattern = '^[a-zA-Z\\,\\.\\_\\;\\- ]*$';

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService) { }

  ngOnInit() { 
    window.scrollTo(0, 0);
  }

  processForm = () => {
    this.userData.name = this.firstName + ' ' + this.lastName;
    this.apiService.postData(Urls.postRequestCallBack, this.commonDataService.convertToString(this.userData)).subscribe((response: any) => {
      if (response.status === 0) {
        this.toastr.success(Thank_You);
      } else {
        this.toastr.error(Something_went_wrong);
      }
    });

  }

  investOnline = () => {
    if(!environment.isDRBuild){
      window.open("https://investonline.itiamc.com/", "_blank");
    }else{
      window.open("https://drinvestor.itiamc.com/", "_blank"); //DR-inv
    }
  }

  public restrictLength(e) {
    var max = 5; 
   }

}
